import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  footerContainer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    flexDirection: 'row', // Align items in a row
    justifyContent: 'space-between', // Space between text and logo
    alignItems: 'center', // Vertically center the content
    fontSize: 10,
    paddingTop: 10,
    paddingLeft: 20,
    paddingRight: 20,
  },
  footerTextContainer: {
    top: 30,
    flex: 1, // This takes up the remaining space
    textAlign: 'center', // Center the text horizontally
  },
  footerText: {
    fontSize: 10,
    textAlign: 'center',
    fontWeight: 1200,
  },
  footerBadge: {
    width: 85,
    height: 85,
  },

  page5footer: {
    color: '#808080',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: 8,
    fontStyle: 'normal',
    fontWeight: 'normal', // Equivalent to font-weight: 400
    lineHeight: 1.5, // line-height is a multiplier in @react-pdf/renderer
    bottom: 40
  }

});

export default styles;
